import React from "react";
import { Chart } from "primereact/chart";

const COLORS = {
    drawdown: "#3b82f6", // Azul para os valores e dados destacados
    accumulated: "#5fa8d3", // Azul claro para a soma acumulada
    returns: "#a3d8f4", // Azul mais claro para os retornos individuais
};

const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            labels: {
                color: "#1d4ed8",
            },
        },
    },
    scales: {
        x: {
            ticks: {
                color: "#1d4ed8",
            },
            grid: {
                offset: true,
            },
            categoryPercentage: 0.8,
            barPercentage: 0.9,
            offset: true,
        },
        y: {
            ticks: {
                color: "#1d4ed8",
            },
            beginAtZero: true,
        },
    },
    layout: {
        padding: {
            left: 30, // Espaço maior à esquerda
            right: 30, // Espaço maior à direita
        },
    },
    elements: {
        bar: {
            maxBarThickness: 40,
        },
    },
};

// Função para formatar valores monetários em reais
function formatBRL(number) {
    if (number === undefined || number === null) {
        return "R$ 0,00";
    }
    return number.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
    });
}

// Função para formatar datas no padrão brasileiro
function formatDate(dateString) {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const date = new Date(dateString);
    return date.toLocaleDateString("pt-BR", options);
}

// Função para formatar datas no gráfico
const formatDates = (dates) => {
    return dates.map((date) => {
        if (date.includes("-")) {
            const parts = date.split("-");
            return `${parts[2]}/${parts[1]}/${parts[0]}`; // yyyy-mm-dd -> dd/mm/yyyy
        }
        return date;
    });
};

const ShowDrawDown = ({ drawdownList, title }) => {
    return (
        <div>
            {/* Título */}
            <div className="mt-4">
                <h2 style={{ color: "black" }}>{title}</h2> {/* Alterado para preto */}
            </div>

            {/* Lista de Drawdowns */}
            {drawdownList.map((drawdown, index) => (
                <div key={index} className="shadow-1 br-1 p-2 mt-2 mb-4">
                    <h3 style={{ color: "black" }}>{`Drawdown #${index + 1}`}</h3>

                    <div className="prsy-grid prsy-col4 justify-content-between text-center mt-3">
                        <div className="flex flex-column border-right-1 border-200">
                            <span style={{ fontSize: "1.2em", fontWeight: "bold", color: COLORS.drawdown }}>
                                {formatDate(drawdown.start_date)}
                            </span>
                            <span style={{ fontSize: "0.7em" }}>Início</span>
                        </div>
                        <div className="flex flex-column border-right-1 border-200">
                            <span style={{ fontSize: "1.2em", fontWeight: "bold", color: COLORS.drawdown }}>
                                {formatDate(drawdown.end_date)}
                            </span>
                            <span style={{ fontSize: "0.7em" }}>Fim</span>
                        </div>
                        <div className="flex flex-column border-right-1 border-200">
                            <span style={{ fontSize: "1.2em", fontWeight: "bold", color: COLORS.drawdown }}>
                                {formatBRL(drawdown.drawdown_em_reais)}
                            </span>
                            <span style={{ fontSize: "0.7em" }}>Drawdown (R$)</span>
                        </div>
                        <div className="flex flex-column">
                            <span style={{ fontSize: "1.2em", fontWeight: "bold", color: COLORS.drawdown }}>
                                {drawdown.duration || 0} dias
                            </span>
                            <span style={{ fontSize: "0.7em" }}>Duração</span>
                        </div>
                    </div>

                    {/* Gráficos */}
                    {drawdown.returns && (
                        <div className="flex flex-column w-full gap-3 mt-3">
                            {/* Gráfico de linha - Soma Acumulada */}
                            <div style={{ height: "400px" }}>
                                <Chart
                                    type="line"
                                    data={{
                                        labels: formatDates(drawdown.returns.datas),
                                        datasets: [
                                            {
                                                label: "Soma Acumulada",
                                                data: drawdown.returns.soma_acumulada_retornos,
                                                borderColor: COLORS.accumulated,
                                                fill: false,
                                                tension: 0.4,
                                            },
                                        ],
                                    }}
                                    options={chartOptions}
                                    style={{ height: "100%" }}
                                />
                            </div>

                            {/* Gráfico de barras - Retornos por período */}
                            <div style={{ height: "400px" }}>
                                <Chart
                                    type="bar"
                                    data={{
                                        labels: formatDates(drawdown.returns.datas),
                                        datasets: [
                                            {
                                                label: "Retornos",
                                                data: drawdown.returns.soma_retornos,
                                                backgroundColor: COLORS.returns,
                                            },
                                        ],
                                    }}
                                    options={chartOptions}
                                    style={{ height: "100%" }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default ShowDrawDown;
